import { useMemo } from "react";

import { useMessengerContext } from "./MessengerContext";

export const useMessengerStoreMainStreamFetchState = () => {
  const {
    allMainStreamFetchState,
    unreadOnlyMainStreamFetchState,
    starredByBrandOnlyMainStreamFetchState,
    showOnlyUnreadConversations,
    showOnlyStarredByBrandConversations,
  } = useMessengerContext() ?? {};

  const mainStreamFetchState = useMemo(() => {
    if (showOnlyUnreadConversations) {
      return unreadOnlyMainStreamFetchState;
    } else if (showOnlyStarredByBrandConversations) {
      return starredByBrandOnlyMainStreamFetchState;
    }
    return allMainStreamFetchState;
  }, [
    showOnlyUnreadConversations,
    showOnlyStarredByBrandConversations,
    allMainStreamFetchState,
    unreadOnlyMainStreamFetchState,
    starredByBrandOnlyMainStreamFetchState,
  ]);

  return useMemo(() => ({ mainStreamFetchState }), [mainStreamFetchState]);
};
